import { useEffect,useState } from "react";
import arrowup from "../../assets/arrowup.png";

import Articles from "../../data/article.js";
import { useParams } from "react-router-dom";
const Fms = ()=>{
    const [fmsarticle, setfmsarticle] = useState({});
    let { articleid } = useParams()
    useEffect(() => {
        const page = document.getElementById('fmstitle');
        page.scrollIntoView({behavior:'smooth',block:'start'});

        const backToTopButton = document.querySelector(".back-to-top");
        const scrollfunc = ()=>{
            if(backToTopButton)
                if(window.scrollY>100){
                    backToTopButton.style.display = "block";
                }else{  
                    backToTopButton.style.display = "none";
                }
        }
        window.addEventListener("scroll", scrollfunc);
        setfmsarticle(Articles[articleid]);
        return () => {
            setfmsarticle({});
        }
       
    },[]);

    return(
        <div id="fms" className="container " style={{paddingTop:"100px"}}>
            <h1 className="pb-5 text-uppercase buildingtech" id="fmstitle">
                {fmsarticle.title}
            </h1>
            <h3 className="text-center pb-5">
                Table of Contents
            </h3>

            <div className="tableparent card mb-5">
                <div className="card-body toc">
                    {fmsarticle.sectionlink}
                </div>
            </div>

            <div className="text-center ">
                <img src={fmsarticle.image} className="fmspic w-75 mb-5"/>
                <p style={{textAlign:"justify", width:"75%", margin:"auto"}}>{fmsarticle.intro}</p>
            </div>
            <div className="articledetail">
              {fmsarticle.sections}
            </div>
            <div>
                <a className="back-to-top"  href="#fmstitle" 
                style={{position: "fixed",bottom:"4%", right:"44%"}}>
                    <img id="back-to-top" src={arrowup} style={{height:"40px", width:"50px"}} className="" alt="arrowup"/> 
                </a>
            </div>
        </div>
    )
}

export default Fms;